export default __webpack_public_path__ + "static/media/stake-more-zen-wbtc.3f482e87.svg";